import { render, staticRenderFns } from "./indiCourseDetails.html?vue&type=template&id=0eccf9e8&scoped=true&external"
import script from "./indiCourseDetails.vue?vue&type=script&lang=ts"
export * from "./indiCourseDetails.vue?vue&type=script&lang=ts"
import style0 from "./indiCourseDetails.scss?vue&type=style&index=0&id=0eccf9e8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eccf9e8",
  null
  
)

export default component.exports